export default {
  // Navigation
  'nav.timer': 'Temporizador',
  'nav.stopwatch': 'Cronômetro',
  'nav.worldclock': 'Relógio Mundial',
  'nav.timestamp': 'Carimbo de Hora',
  'nav.home': 'Página Inicial',

  // Common buttons and actions
  'button.start': 'Iniciar',
  'button.pause': 'Pausar',
  'button.stop': 'Parar',
  'button.reset': 'Redefinir',
  'button.ok': 'OK',
  'button.cancel': 'Cancelar',
  'button.close': 'Fechar',
  'button.save': 'Salvar',
  'button.delete': 'Excluir',
  'button.edit': 'Editar',
  'button.back': 'Voltar',
  'button.next': 'Próximo',
  'button.previous': 'Anterior',
  'button.submit': 'Enviar',
  'button.confirm': 'Confirmar',
  'button.convert': 'Converter',
  'button.copy': 'Copiar',
  'button.copied': 'Copiado!',
  'button.now': 'Agora',
  'button.clear': 'Limpar',

  // Common labels
  'label.hours': 'Horas',
  'label.minutes': 'Minutos',
  'label.seconds': 'Segundos',
  'label.milliseconds': 'Milissegundos',
  'label.minute': 'Minuto',
  'label.second': 'Segundo',
  'label.sound': 'Som',
  'label.soundAlert': 'Som',
  'label.fullscreen': 'Tela Cheia',
  'label.language': 'Idioma',
  'label.selectLanguage': 'Selecione o Idioma',
  'label.languageSelectorInfo': 'Atualmente suporta {{count}} idiomas. Selecione seu idioma preferido nas opções acima.',

  // Common messages
  'message.timerComplete': 'Temporizador Concluído!',
  'message.timerCompleteDesc': 'Seu temporizador foi concluído',
  'message.timerCompleteBody': 'Seu temporizador de contagem regressiva foi concluído!',
  'message.stopwatchStarted': 'Cronômetro Iniciado',
  'message.stopwatchStartedDesc': 'A cronometragem foi iniciada',
  'message.stopwatchStopped': 'Cronômetro Parado',
  'message.stopwatchStoppedDesc': 'A cronometragem foi pausada',
  'message.stopwatchReset': 'Cronômetro Redefinido',
  'message.stopwatchResetDesc': 'O cronômetro foi redefinido para zero',
  'message.notificationPermission': 'Permita notificações para receber alertas quando o temporizador terminar',
  'message.clickToEdit': 'Clique nos números de tempo para editar o tempo diretamente',
  'message.addHours': '+ Adicionar Horas',
  'message.escToExit': 'Pressione ESC para sair da tela cheia',
  'message.timeRemaining': '{{minutes}} minutos {{seconds}} segundos restantes',
  'message.minutesRemaining': '{{minutes}} minutos restantes',
  'message.secondsRemaining': '{{seconds}} segundos restantes',
  'message.stopwatchTimeElapsed': '{{minutes}} minutos {{seconds}} segundos decorridos',
  'message.stopwatchMinutesElapsed': '{{minutes}} minutos decorridos',
  'message.stopwatchSecondsElapsed': '{{seconds}} segundos decorridos',
  'message.invalidTimestamp': 'Carimbo de hora inválido',
  'message.invalidDateTime': 'Data e hora inválidas',
  'message.conversionError': 'Erro de conversão',

  // Time units
  'time.am': 'AM',
  'time.pm': 'PM',
  'time.now': 'Agora',
  'time.today': 'Hoje',
  'time.yesterday': 'Ontem',
  'time.tomorrow': 'Amanhã',

  // Common errors
  'error.pageNotFound': 'Página Não Encontrada',
  'error.somethingWrong': 'Algo deu errado',
  'error.tryAgain': 'Por favor, tente novamente mais tarde',

  // Footer
  'footer.about': 'Sobre timer.today',
  'footer.aboutDesc': 'timer.today é uma plataforma profissional de ferramentas de cronometragem online que oferece três recursos principais:',
  'footer.timerDesc': 'Ferramenta de contagem regressiva personalizável com suporte a configurações de minutos e horas, perfeita para foco no trabalho, cronometragem de culinária, gerenciamento de estudos e muito mais. Oferece alertas sonoros e notificações de desktop.',
  'footer.stopwatchDesc': 'Ferramenta de cronometragem de alta precisão com precisão de milissegundos, adequada para treinamento esportivo, operações culinárias, prática de exames e outros cenários que exigem cronometragem precisa.',
  'footer.worldClockDesc': 'Exibição em tempo real dos horários das principais cidades do mundo com cálculos inteligentes de fuso horário, facilitando a comunicação comercial internacional e a colaboração entre fusos horários.',
  'footer.timestampDesc': 'Conversor de carimbo de hora Unix que suporta conversão bidirecional entre carimbo de hora e data/hora, com suporte aos formatos de segundos e milissegundos.',
  'footer.termsOfService': 'Termos de Serviço',
  'footer.privacy': 'Privacidade',
  'footer.contactUs': 'Entre em Contato',
  'footer.changeLanguage': 'mudar idioma',
  'footer.moreLanguage': 'mais idiomas',
  'footer.copyright': '© timer.today 2024',

  // Quick actions
  'quick.add30s': '+30s',
  'quick.add1min': '+1 Min',
  'quick.add5min': '+5 Min',
  'quick.add10min': '+10 Min',
  'quick.add30min': '+30 Min',

  // Breadcrumb
  'breadcrumb.minuteTimer': 'Temporizador de {{minutes}} Minutos',
  'breadcrumb.timer': 'Temporizador',
  'breadcrumb.stopwatch': 'Cronômetro',
  'breadcrumb.worldClock': 'Relógio Mundial',
  'breadcrumb.termsOfService': 'Termos de Serviço',
};